export default __webpack_public_path__ + "seats.f74c181193d61f3b.svg";